module.exports = __webpack_public_path__ + "img/TECHNOLOGY-ERTIGA-BOOSTER-GREEN-2.aa10d49d.jpg";